import React from 'react';
import IdleTimer from 'react-idle-timer';
import { useGenericState } from './Library/UseGenericState';
import { setForceLogout } from './actions/authentication';
import store from 'src/store/appStore';
import moment from 'moment';

const dispatch = store.dispatch;

interface IIdleTimeProps {
  authSettings?: {
    idle_session_timeout?: number;
  };
}

const DEFAULT_TIMEOUT = 1000 * 7 * 24 * 60 * 60;

const IdleTime = (props: IIdleTimeProps) => {
  const timeout = props.authSettings?.idle_session_timeout || DEFAULT_TIMEOUT;

  const [state, setState] = useGenericState({
    isTimedOut: false,
  });

  const { isTimedOut } = state;

  let idleTimer;

  const updateLastActionTime = () => {
    window.localStorage.setItem('lastActionTime', String(new Date()));
  };

  const onAction = (e) => {
    updateLastActionTime();
    setState({ isTimedOut: false });
  };

  React.useEffect(() => {
    const lastActionTime = window.localStorage.getItem('lastActionTime');
    if (timeout && lastActionTime) {
      if (moment().diff(lastActionTime, 'millisecond') > timeout) {
        dispatch(setForceLogout());
      }
    }
  }, []);

  const onActive = (e) => {
    setState({ isTimedOut: false });
    updateLastActionTime();
  };

  const onIdle = (e) => {
    const lastActionTime = window.localStorage.getItem('lastActionTime');
    if (isTimedOut || (lastActionTime && moment().diff(lastActionTime, 'millisecond') > timeout)) {
      dispatch(setForceLogout());
    } else {
      idleTimer.reset();
      setState({ isTimedOut: true });
    }
  };

  return (
    <>
      <IdleTimer
        ref={(ref) => {
          idleTimer = ref;
        }}
        element={document}
        onActive={onActive}
        onIdle={onIdle}
        onAction={onAction}
        debounce={250}
        timeout={timeout}
      />
    </>
  );
};

export default IdleTime;
